module.exports = "<h4 class=\"text-center\">Coming soon...</h4>"